/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorAdunit as ResolvedLabradorAdunit } from 'base/components/labrador/Adunit';

export const LabradorAdunit: typeof ResolvedLabradorAdunit = withLabradorInstanceof((props) => {
    return <ResolvedLabradorAdunit {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorAdunitProps = PropsFromComponent<typeof LabradorAdunit>;
